module.exports = __webpack_public_path__ + "img/pos-crossroads.9a17f7c0.png";